import type {Feature} from 'ol';
import type {Coordinate} from 'ol/coordinate';

export function clearHighlight(force: boolean) {
  highlightFunctions.clearHighlight(force);
}

export function highlight(feature: Feature, persistent: boolean) {
  highlightFunctions.highlight(feature, persistent);
}

export function unhighlight(feature: Feature) {
  highlightFunctions.unhighlight(feature);
}

export function highlightPosition(
  coordinates: Coordinate,
  iconFileName?: string,
) {
  highlightFunctions.highlightPosition(coordinates, iconFileName);
}

type HighlightFunctions = {
  clearHighlight: (force: boolean) => void;
  highlight: (feature: Feature, persistent: boolean) => void;
  unhighlight: (feature: Feature) => void;
  highlightPosition: (coordinates: Coordinate, iconFileName?: string) => void;
};
let highlightFunctions: HighlightFunctions = {
  clearHighlight(force: boolean) {},
  highlight(feature: Feature, persistent: boolean) {},
  unhighlight(feature: Feature) {},
  highlightPosition(coordinate: Coordinate) {},
};

export function setHighlightFunctions(fns: HighlightFunctions) {
  highlightFunctions = fns;
}
